(function () {

  function waitForSlick(callback) {
    if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
      setTimeout(function () { waitForSlick(callback); }, 50);
      return;
    }
    callback();
  }

  // ─── Testimonial Slider (ts3) ───────────────────────────────────────────────

  function initTS3() {
    jQuery('.ts3-slider').each(function () {
      var $slider = jQuery(this);
      if ($slider.hasClass('slick-initialized')) return;

      var autoplay      = $slider.data('autoplay') === 'true';
      var autoplaySpeed = parseInt($slider.data('autoplay-speed')) || 3000;

      $slider.slick({
        slidesToShow:   3,
        slidesToScroll: 1,
        infinite:       true,
        autoplay:       autoplay,
        autoplaySpeed:  autoplaySpeed,
        prevArrow:      $slider.closest('.ts3-wrap').find('.ts3-btn--prev'),
        nextArrow:      $slider.closest('.ts3-wrap').find('.ts3-btn--next'),
        responsive: [
          {
            breakpoint: 1000,
            settings: {
              slidesToShow:   2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow:   1,
              slidesToScroll: 1
            }
          }
        ]
      });

      // Disabled state on prev/next
      $slider.on('afterChange', function (e, slick, currentSlide) {
        var $wrap = $slider.closest('.ts3-wrap');
        $wrap.find('.ts3-btn--prev').toggleClass('ts3-btn--disabled', currentSlide === 0);
        $wrap.find('.ts3-btn--next').toggleClass('ts3-btn--disabled', currentSlide >= slick.slideCount - slick.options.slidesToShow);
      }).trigger('afterChange', [$slider[0], $slider[0].slick, 0]);
    });
  }

  // ─── Product List Slider (plb) ──────────────────────────────────────────────

  // function initPLB() {
  //   jQuery('.plb-slider').each(function () {
  //     var $slider = jQuery(this);
  //     if ($slider.hasClass('slick-initialized')) return;

  //     var slidesToShow   = parseInt($slider.data('slides-to-show')) || 4;
  //     var slidesToScroll = parseInt($slider.data('slides-to-scroll')) || 1;
  //     var autoplay       = $slider.data('autoplay') === 'true';
  //     var autoplaySpeed  = parseInt($slider.data('autoplay-speed')) || 3000;
  //     var $dots          = $slider.closest('.plb-content').find('.plb-dots');

  //     $slider.slick({
  //       slidesToShow:   slidesToShow,
  //       slidesToScroll: slidesToScroll,
  //       infinite:       false,
  //       autoplay:       autoplay,
  //       autoplaySpeed:  autoplaySpeed,
  //       arrows:         false,
  //       dots:           true,
  //       appendDots:     $dots,
  //       responsive: [
  //         {
  //           breakpoint: 992,
  //           settings: {
  //             slidesToShow:   2,
  //             slidesToScroll: 1
  //           }
  //         },
  //         {
  //           breakpoint: 768,
  //           settings: {
  //             slidesToShow:   2,
  //             slidesToScroll: 1
  //           }
  //         },
  //         {
  //           breakpoint: 600,
  //           settings: {
  //             slidesToShow:   1,
  //             slidesToScroll: 1
  //           }
  //         }
  //       ]
  //     });
  //   });
  // }

  // ─── Boot ───────────────────────────────────────────────────────────────────

  function init() {
    waitForSlick(function () {
      initTS3();
      // initPLB();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();